const BoxDetailsGrid = ({ rows = [] }) => {
  if (!rows.length) return null
  return (
    <div className="pdf-box-grid">
      {rows.map(([serial, label, value]) => (
        <div key={serial} className="pdf-box-cell">
          <div className="pdf-box-label">{label}</div>
          <div className="pdf-box-value">{value}</div>
        </div>
      ))}
    </div>
  )
}

export default BoxDetailsGrid
